import type { AppBranding } from "@atoms/atom-client";

export const projectBranding = {
  appName: "AP51",
  logo: {
    src: "/logo.png",
    alt: "AP51",
  },
} satisfies AppBranding;
